import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import OperationalTable from '../../../organisms/OperationalTable'
import SydActionMenu from '../../../commonDesign/SydActionMenu'

function DelegatedIdentityTable ({ identities, onRowClick, onEnable, onDisable, onEdit, onDelete }) {
  const columns = useMemo(() => [
    { id: 'displayName', accessor: 'displayName', Header: 'Display Name' },
    {
      id: 'code',
      accessor: 'code',
      Header: 'Code',
      // eslint-disable-next-line react/prop-types
      Cell: ({ value }) => <code>{value}</code>
    },
    {
      id: 'userId',
      accessor: 'userId',
      Header: 'User',
      // eslint-disable-next-line react/prop-types
      Cell: ({ row }) => {
        // eslint-disable-next-line react/prop-types
        const { userLastName, userFirstName, userId } = row.original
        const name = [userLastName, userFirstName].filter(Boolean).join(', ')
        return name ? `${name} (${userId})` : `User ${userId}`
      }
    },
    {
      id: 'enabled',
      accessor: 'enabled',
      Header: 'Enabled',
      // eslint-disable-next-line react/prop-types
      Cell: ({ value }) => value ? 'Yes' : 'No'
    },
    {
      id: 'actions',
      Header: '',
      disableSortBy: true,
      /* eslint-disable react/prop-types */
      Cell: ({ row }) => {
        const identity = row.original
        const actions = [
          identity.enabled
            ? { key: 'disable', label: 'Disable', icon: 'pause', onClick: () => onDisable(identity) }
            : { key: 'enable', label: 'Enable', icon: 'play_arrow', onClick: () => onEnable(identity) },
          { key: 'edit', label: 'Edit', icon: 'edit', onClick: () => onEdit(identity) },
          { key: 'delete', label: 'Delete', icon: 'delete', onClick: () => onDelete(identity) }
        ]
        return (
          <div onClick={(e) => e.stopPropagation()}>
            <SydActionMenu actions={actions} />
          </div>
        )
      }
      /* eslint-enable react/prop-types */
    }
  ], [onEnable, onDisable, onEdit, onDelete])

  return (
    <OperationalTable
      variant='v2'
      columns={columns}
      data={identities}
      defaultSort={[{ id: 'displayName', desc: false }]}
      onRowClick={onRowClick}
    />
  )
}

DelegatedIdentityTable.propTypes = {
  identities: PropTypes.array.isRequired,
  onRowClick: PropTypes.func,
  onEnable: PropTypes.func.isRequired,
  onDisable: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}

export default DelegatedIdentityTable
